var __jsx = React.createElement;
import React, { useEffect } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { faMessageBot } from "@fortawesome/pro-duotone-svg-icons";
import PatientSummary from "../PatientSummary";
import { useCopilotChat } from "@copilotkit/react-core";
import { Role, TextMessage } from "@copilotkit/runtime-client-gql";
var CustomAssistantMessage = function CustomAssistantMessage(props) {
  var message = props.message,
    isLoading = props.isLoading,
    subComponent = props.subComponent;
  var loadingKeys = ["Analyzing clinical context...", "Compiling patient data...", "Processing medical records...", "Interpreting inputs...", "Reviewing patient information...", "Gathering relevant details...", "Synchronizing with medical database..."];
  var currentIndex = Math.floor(Math.random() * loadingKeys.length);
  var isPatientSummary = message === null || message === void 0 ? void 0 : message.includes("<<<PATIENT_SUMMARY_JSON>>>");
  var _useCopilotChat = useCopilotChat(),
    visibleMessages = _useCopilotChat.visibleMessages,
    setMessages = _useCopilotChat.setMessages,
    appendMessage = _useCopilotChat.appendMessage;
  useEffect(function () {
    var _visibleMessages;
    if (((_visibleMessages = visibleMessages[visibleMessages.length - 1]) === null || _visibleMessages === void 0 ? void 0 : _visibleMessages.content) === "❌ An error occurred. Please try again.") {
      setMessages(visibleMessages.slice(0, -1));
      setTimeout(function () {
        appendMessage(new TextMessage({
          content: "Please start a new chat to continue.",
          role: Role.Assistant
        }), {
          followUp: false
        });
      }, 1000);
    }
  }, [visibleMessages]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, message && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start mb-4 last:mb-0 justify-start"
  }, !subComponent && /*#__PURE__*/React.createElement("div", {
    className: "p-1 mt-2 rounded-full border-0 border-teal-300 flex items-center justify-center mr-2 flex-shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMessageBot,
    size: "lg",
    className: "text-teal-300"
  })), isPatientSummary ? /*#__PURE__*/React.createElement(PatientSummary, {
    message: message
  }) : /*#__PURE__*/React.createElement("div", {
    className: "px-5 py-4 rounded-lg max-w-[75%] bg-gray-800 text-white rounded-tl-none"
  }, /*#__PURE__*/React.createElement("p", {
    className: "whitespace-pre-wrap"
  }, message))), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 mb-6 my-2"
  }, subComponent), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3 text-gray-400 pl-8"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSpinner,
    size: "lg",
    className: "animate-spin"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-md italic"
  }, loadingKeys[currentIndex])));
};
export default CustomAssistantMessage;